
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-link-generator",
      function () {
        return require("private-next-pages/whatsapp-link-generator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-link-generator"])
      });
    }
  